import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CustomerTestsTypes } from '@enums/customer-tests-types';
import { environment } from '@environments/environment';
import { PartialResultsDeliveryResponse } from '@models/partial-results-delivery-response';
import { StorageService } from '@services/storage.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PartialResultsDeliveryService {
  private http = inject(HttpClient);
  private storageService = inject(StorageService);

  /**
   * Get the Partial Results Delivery content.
   *
   * @returns an Observable of the PartialResultsDeliveryResponse
   */
  public getPartialResultsDeliveryContent(): Observable<PartialResultsDeliveryResponse> {
    return this.http
      .get(`${environment.analyteCareApi}/api/v2/public-files/partial-results-delivery.json`, { responseType: 'text' })
      .pipe(map((responseText) => JSON.parse(responseText)));
  }

  /**
   * Determines if the user should be redirected to the partial results delivery page.
   */
  public shouldRedirectToPartialResultsDelivery(): boolean {
    const orderedTests = this.storageService.orderedTests;

    if (orderedTests.length > 1) {
      return true;
    }

    return orderedTests.some((test) => test.type === CustomerTestsTypes.Panel);
  }
}
